import { render, staticRenderFns } from "./disRecord.vue?vue&type=template&id=52100eac&"
import script from "./disRecord.vue?vue&type=script&lang=js&"
export * from "./disRecord.vue?vue&type=script&lang=js&"
import style0 from "./disRecord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports